export default __webpack_public_path__ + "static/media/excel.9e88926a.png";